const _origin = process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:9100";
const _prefix = process.env.NEXT_PUBLIC_BACKEND_PREFIX ?? "";
export const BASE = `${_origin}${_prefix}`;

export async function extractError(res: Response): Promise<string> {
  const text = await res.text();
  if ((res.headers.get("content-type") ?? "").includes("application/json")) {
    return JSON.parse(text).detail ?? text;
  }
  return text;
}

export function errMsg(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

export class UnauthorizedError extends Error {
  constructor(message = "未登录或登录已失效") {
    super(message);
    this.name = "UnauthorizedError";
  }
}

export function handleUnauthorized() {
  if (typeof window === "undefined") return;
  if (window.location.pathname === "/login") return;
  window.location.href = "/login";
}

export async function authFetch(path: string, init?: RequestInit): Promise<Response> {
  const res = await fetch(`${BASE}${path}`, { credentials: "include", ...init });
  if (res.status === 401) {
    handleUnauthorized();
    throw new UnauthorizedError();
  }
  return res;
}

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await authFetch(path, init);
  if (!res.ok) throw new Error(await extractError(res));
  return res.json() as Promise<T>;
}

export async function postForm(path: string, fd: FormData): Promise<Response> {
  const res = await authFetch(path, { method: "POST", body: fd });
  if (!res.ok) throw new Error(await extractError(res));
  return res;
}
